import initialState from '../core/initialState';
import Event from '../core/Event';
import UserEstimationDetails from 'src/domain/SummaryData';
import UserEstimationGetSucceed from '../estimations/events/UserEstimationGetSucceed';

export default (state: UserEstimationDetails | null = initialState.estimationDetails, anyEvent: Event): UserEstimationDetails | null => {
    switch (anyEvent.type) {
        case UserEstimationGetSucceed.type:
            return (anyEvent as UserEstimationGetSucceed).estimation;
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/estimation-details/reducer.ts